import styled from 'styled-typed'
import { DashboardTheme } from 'theme'

export type FontWeightType = 'light' | 'regular' | 'medium' | 'bold'

const weight = {
    light: '300',
    regular: '400',
    medium: '500',
    bold: '700',
}

interface HeadlineProps {
    size: 1 | 2 | 3 | 4 | 5 | 6
    bold?: boolean
    color?: TextColor
}
const headlineSizes = {
    1: '2.625rem',
    2: '2.125rem',
    3: '1.75rem',
    4: '1.375rem',
    5: '1.125rem',
    6: '0.875rem',
}
export const Headline = styled.div<HeadlineProps>`
    margin: 0 0 1rem 0;
    font-family: Roboto;
    color: ${(props) => getColor(props.theme, props.color)};
    font-size: ${(props) => headlineSizes[props.size] || '1rem'};
    line-height: 150%;
    font-weight: ${(props) => (props.bold ? '700' : '500')};
`

export const Subtitle = styled.div`
    color: ${(props) => props.theme.colors.textDark};
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: 300;
`

interface CaptionProps {
    color?: TextColor
}

export const Caption = styled.div<CaptionProps>`
    color: ${(props) => getColor(props.theme, props.color)};
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 400;
`

type TextColor = 'primary' | 'light' | 'white' | 'richBlack'

const getColor = (theme: DashboardTheme, color?: TextColor): string => {
    switch (color) {
        case 'light':
            return theme.colors.textLight
        case 'white':
            return theme.colors.white
        case 'richBlack':
            return theme.colors.richBlack
        default:
            return theme.colors.textDark
    }
}

interface BodyProps {
    size?: 1 | 2 | 3
    weight?: FontWeightType
    color?: TextColor
}

const bodySizes = {
    1: { font: '0.875rem', line: '1.5rem' },
    2: { font: '0.75rem', line: '1.25rem' },
    3: { font: '0.625rem', line: '1rem' },
}

export const Body = styled.div<BodyProps>`
    font-size: ${(props) => bodySizes[props.size ?? 1]?.font || '1rem'};
    line-height: ${(props) => bodySizes[props.size ?? 1]?.line || '1rem'};
    font-weight: ${(props) => weight[props.weight || 'regular']};
    color: ${(props) => getColor(props.theme, props.color)};
`
